import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/auth/LoginPage';
import CreateAccount from '../pages/auth/userRegistration/CreateAccount';
import ForgotPassword from '../pages/auth/userRegistration/ForgotPassword';
import OtpVerification from '../pages/auth/userRegistration/VerifyOTP';
import ForgotOtpVerification from '../pages/auth/userRegistration/ForgotVerifyOTP';
import SetPassword from '../pages/auth/userRegistration/SetPassword';
import SetforgotPassword from '../pages/auth/userRegistration/SetNewPassword';
// import Messages from '../pages/figma/Messages';
import { PrivateRoute, PublicRoute, ManagerCenterRoute } from './guards';
import WorkShiftPage from '../pages/figma/UserInfo/workShift/WorkShift';
import Gender from '../pages/figma/UserInfo/genderSelection/GenderSelection';
import ReligiousAssociation from '../pages/figma/UserInfo/ReligiousAssociation/ReligiousAssociation';

import { useNavigate } from 'react-router-dom';
import MyProfile from '../pages/figma/UserInfo/userProfile/UserProfile';

import MatchProfile from '../pages/matchProfile/MatchProfile';
import Menu from '../pages/menu/Menu';
import UserDashboard from '../pages/figma/UserInfo/UserDashboard';
import OnlineSafetyScreen from '../pages/onlineSafety/OnlineSafetyScreen';
import HelpCenterScreen from '../pages/HelpCenter/HelpCenterScreen';
import TermsConditionsScreen from '../pages/TermsConditions/TermsConditionsScreen';
import TermsConditionsScreenPriavate from '../pages/TermsConditions/TermsConditionsScreenPrivate';
import PrivacyPolicyScreenPrivate from '../pages/PrivacyPolicy/PrivacyPolicyScreenPrivate';
import PrivacyPolicyScreen from '../pages/PrivacyPolicy/PrivacyPolicyScreen';
import OverViewMessages from '../pages/figma/UserInfo/messages/Messages';
import SendMessage from '../pages/figma/UserInfo/messages/SendMessage';
import ResetPassword from '../pages/auth/userRegistration/ResetPassword';
import ResetPasswordConfirm from '../pages/auth/userRegistration/ResetPasswordConfirm';
import MessageChatWrapper from "../pages/figma/UserInfo/messageChat/MessageChatWrapper";
import MessageChat from "../pages/figma/UserInfo/messageChat/MessageChat";
import Notifications from '../pages/figma/UserInfo/Notifications';
import ChildSafetyScreen from '../pages/childSafety/ChildSafetyScreen';
import ChildSafetyScreenPrivate from '../pages/childSafety/ChildSafetyScreenPrivate';
import ITworkType from '../pages/figma/UserInfo/workType/WorkType';
import FlowRoute from '../components/routing/FlowRoute';
import { AppFieldKey } from '../config/fieldConfig';
import CreatePostScreen from "../pages/figma/Post/CreatePostScreen";
import ViewPostScreen from "../pages/figma/Post/viewPostScreen";
import EditPostScreen from "../pages/figma/Post/EditPostScreen";
import ThemeSettings from '../pages/ThemeSettings';
import DashboardLayout from '../components/DashboardLayout';
import ConnectingInformation from '../pages/ConnectingInformation';
import ChangePassword from '../pages/ChangePassword';
import FindPeopleScreen from "../pages/figma/FindPeople/findPeopleScreen";
import GroupsPage from '../pages/groups/GroupsPage';
//import GroupChatPage from '../pages/groups/GroupChatPage';
import GroupChatPageEnhanced from '../pages/groups/GroupChatPageEnhanced';
import SavedListsPage from '../pages/savedLists/SavedListsPage';
import SavedListDetailsPage from '../pages/savedLists/SavedListDetailsPage';
import AboutPage from '../pages/about/AboutPage';
import MyFeedbackPage from '../pages/feedback/MyFeedbackPage';
import WishlistPage from '../pages/wishlist/WishlistPage';
import ReportsPage from '../pages/reports/ReportsPage';
import AvailabilityApprovals from '../pages/availability/AvailabilityApprovals';
import SkillApprovals from '../pages/skills/SkillApprovals';
import CompleteProfileForm from '../pages/figma/UserInfo/CompleteProfileForm';
import TalentSearchPage from '../pages/talentSearch/TalentSearchPage';
import WorkforceIntelligencePage from '../pages/workforceIntelligence/WorkforceIntelligencePage';
import NotFoundPage from '../pages/NotFoundPage';

interface ActiveChat {
  receiverId: string;
  userName: string;
  photoId?: string;
}

function OverviewMessagesScreen() {
  const [activeChat, setActiveChat] = useState<ActiveChat | null>(null);

  return (
    <DashboardLayout
      title="Messages"
      contentClassName={activeChat ? "h-full min-h-0 overflow-hidden" : undefined}
    >
      {activeChat ? (
        <MessageChat
          userId={activeChat.receiverId}
          userName={activeChat.userName}
          userPhotoId={activeChat.photoId}
          onBack={() => setActiveChat(null)}
        />
      ) : (
        <OverViewMessages
          onOpenChat={(receiverId, userName, photoId) =>
            setActiveChat({ receiverId, userName, photoId })
          }
        />
      )}
    </DashboardLayout>
  );
}

function NotificationsScreen() {
  const [activeChat, setActiveChat] = useState<ActiveChat & { scrollToMessageId?: number } | null>(null);
  const navigate = useNavigate();

  return (
    <DashboardLayout
      title="Notifications"
      contentClassName={activeChat ? "h-full min-h-0 overflow-hidden" : undefined}
    >
      {activeChat ? (
        <MessageChat
          userId={activeChat.receiverId}
          userName={activeChat.userName}
          userPhotoId={activeChat.photoId}
          scrollToMessageId={activeChat.scrollToMessageId}
          onBack={() => setActiveChat(null)}
        />
      ) : (
        <Notifications
          onBack={() => navigate('/dashboard')}
          onOpenChat={setActiveChat}
        />
      )}
    </DashboardLayout>
  );
}

function MatchProfileScreen() {
  const [activeChat, setActiveChat] = useState<ActiveChat | null>(null);

  return (
    <DashboardLayout
      title="Member Profile"
      contentClassName={activeChat ? "h-full min-h-0 overflow-hidden" : undefined}
    >
      {activeChat ? (
        <MessageChat
          userId={activeChat.receiverId}
          userName={activeChat.userName}
          userPhotoId={activeChat.photoId}
          onBack={() => setActiveChat(null)}
        />
      ) : (
        <MatchProfile
          onOpenChat={(receiverId, userName, photoId) =>
            setActiveChat({ receiverId, userName, photoId })
          }
        />
      )}
    </DashboardLayout>
  );
}

const AppRoutes: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route element={<PublicRoute redirectTo="/dashboard" />}>
        <Route path="/" element={<LoginPage />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route
          path="/verify-otp"
          element={
            <OtpVerification
              onBack={() => navigate('/create-account')}
              onContinue={() => navigate('/setpassword')}
            />
          }
        />

        <Route
          path="/setpassword"
          element={
            <SetPassword
              onBack={() => navigate('/verify-otp')}
              onContinue={() => navigate('/personal-details')}
            />
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/Forgot-verify-otp"
          element={
            <ForgotOtpVerification
              onBack={() => navigate('/forgot-password')}
              onContinue={() => navigate('/SetforgotPassword')}
            />
          }
        />

        <Route
          path="/SetforgotPassword"
          element={
            <SetforgotPassword
              onBack={() => navigate('/Forgot-verify-otp')}
              onContinue={() => navigate('/')}
            />
          }
        />

      </Route>
      <Route path="/auth/action" element={<ResetPasswordConfirm />} />
      <Route path="/PrivacyPolicy" element={<PrivacyPolicyScreen />} />
      <Route path="/childsafety" element={<ChildSafetyScreen />} />
      <Route path="/TermsConditions" element={<TermsConditionsScreen />} />
      <Route element={<PrivateRoute redirectTo="/" />}>

        <Route path="/PrivacyPolicyPrivate" element={<PrivacyPolicyScreenPrivate />} />
        <Route path="/childsafetyPrivate" element={<ChildSafetyScreenPrivate />} />


        <Route
          path="/OverViewMessages"
          element={<OverviewMessagesScreen />}
        />

        <Route
          path="/my-profile"
          element={
            <MyProfile
              onBack={() => navigate('/marital-Status')}
              onOpenMenu={() => navigate('/menu')}
            />
          }
        />





        <Route path="/dashboard" element={
          <DashboardLayout title="Dashboard">
            <UserDashboard />
          </DashboardLayout>
        } />
        <Route
          path="/notifications"
          element={<NotificationsScreen />}
        />
      
      </Route>

      <Route element={<PrivateRoute redirectTo="/" />}>
        {/* <Route path="/messages" element={<Messages />} /> */}
        <Route path="/menu" element={<Menu onClose={() => navigate(-1)} />} />
              

        <Route
          path="/reset-password"
          element={
            <ResetPassword
              onBack={() => navigate('/menu')}
              onContinue={() => navigate('/')}
            />
          }
        />

        <Route
          path="/MemberProfile"
          element={<MatchProfileScreen />}
        />
        <Route
          path="/MatchProfile"
          element={<MatchProfileScreen />}
        />
       
        <Route
          path="/religious-association"
          element={
            <ReligiousAssociation
              onBack={() => navigate('/weight-selection')}
              onContinue={() => navigate('/ethnicity')}
            />
          }
        />
       

        <Route
          path="/work-shift"
          element={
            <WorkShiftPage
              onBack={() => navigate('/ethnicity')}
              onContinue={() => navigate('/marital-Status')}
            />
          }
        />     

        <Route
          path="/gender-selection"
          element={
            <Gender
              onBack={() => navigate('/IT-skills')}
              onContinue={() => navigate('/height-selection')}
            />
          }
        />                 
    
        <Route
          path="/personal-details"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-specialty"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-skills"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-workType"
          element={
            <DashboardLayout title="Work Type">
              <FlowRoute
                fieldKey={AppFieldKey.WorkType}
                render={(goBack, goNext) => (
                  <ITworkType onBack={goBack} onContinue={goNext} />
                )}
              />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-AvailabilityType"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-ExploreTechnologies"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-TotalExperience"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/IT-workOrganizationCount"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        <Route
          path="/tellup-about"
          element={
            <DashboardLayout title="My Profile">
              <CompleteProfileForm />
            </DashboardLayout>
          }
        />
        {/* <Route
          path="/CreatePost"
          element={
            <CreatePost
              onBack={() => navigate('/my-profile')}
              onContinue={() => navigate('/my-profile')}
            />
          }
        /> */}


        <Route path="/CreatePost" element={<CreatePostScreen />} />
        <Route path="/findPeople" element={<FindPeopleScreen />} />
        <Route path="/groups" element={
          <DashboardLayout title="List">
            <GroupsPage />
          </DashboardLayout>
        } />
        <Route path="/groups/:groupId" element={
          <DashboardLayout title="List">
            <GroupChatPageEnhanced />
          </DashboardLayout>
        } />
        <Route path="/saved-lists" element={
          <DashboardLayout title="Private Lists">
            <SavedListsPage />
          </DashboardLayout>
        } />
        <Route path="/saved-lists/:id" element={
          <DashboardLayout title="Private Lists">
            <SavedListDetailsPage />
          </DashboardLayout>
        } />
        <Route path="/send-message" element={
          <DashboardLayout title="Send Message">
            <SendMessage />
          </DashboardLayout>
        } />
        <Route path="/about" element={
          <DashboardLayout title="About">
            <AboutPage />
          </DashboardLayout>
        } />
        <Route path="/my-feedback" element={
          <DashboardLayout title="My Feedback">
            <MyFeedbackPage />
          </DashboardLayout>
        } />
        <Route path="/wishlist" element={
          <DashboardLayout title="Wishlist">
            <WishlistPage />
          </DashboardLayout>
        } />
        <Route element={<ManagerCenterRoute />}>
          <Route path="/reports" element={
            <DashboardLayout title="Reports">
              <ReportsPage />
            </DashboardLayout>
          } />
          <Route path="/availability-approvals" element={
            <DashboardLayout title="Availability Approvals">
              <AvailabilityApprovals />
            </DashboardLayout>
          } />
          <Route path="/skill-approvals" element={
            <DashboardLayout title="Skill Approvals">
              <SkillApprovals />
            </DashboardLayout>
          } />
          <Route path="/workforce-intelligence" element={
            <DashboardLayout title="Workforce Intelligence">
              <WorkforceIntelligencePage />
            </DashboardLayout>
          } />
        </Route>
        <Route path="/ask-isentryx-ai" element={
          <DashboardLayout title="Talent & Expert Finder">
            <TalentSearchPage />
          </DashboardLayout>
        } />
        <Route path="/viewPost" element={<ViewPostScreen />} />
        <Route path="/posts/:postId" element={<ViewPostScreen />} />
        <Route path="/edit-post/:postId" element={<EditPostScreen />} />
        <Route path="/theme-settings" element={<ThemeSettings />} />
        <Route path="/connecting-info" element={<ConnectingInformation />} />
        <Route path="/change-password" element={<ChangePassword />} />

        <Route path="/OnlineSafety" element={<OnlineSafetyScreen />} />

        <Route path="/HelpCenter" element={<HelpCenterScreen />} />
        <Route
          path="/messageChat/:receiverId/:userName"
          element={<MessageChatWrapper />}
        />
      </Route>

      <Route path="/TermsConditionsPraivate" element={<TermsConditionsScreenPriavate />} />

      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
};

export default AppRoutes;
